const state = {
  dictionaryList: [], //字典
  dictionary: [],
  memberTypeList: [], //会员类型
  branchsList: [], //单位
  zhichengList: [], //职称
  cityList: [], //城市
  access_token: "",
  refresh_token: "",
  userInfo: {}, //会员信息
  titleList:[],
  addrList:[]
};

export default state;
